import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  buildNumber = environment.ENVIRONMENT != 'production' ? environment.BITBUCKET_BUILD_NUMBER : undefined;
  currentYear = new Date().getFullYear();

  constructor() { }

  ngOnInit(): void {
  }

}
